import OnlyHeader from "components/Layout/OnlyHeader";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Container } from "reactstrap";
import MenuLabels from "components/Menu/Labels/index";
import Menu from "components/Menu";
import WaiterMenu from "components/Menu/WaiterMenu";
import Tabs from "components/Menu/Tabs/Tabs";
import { useLocation, useHistory } from "react-router-dom";
import AddOns from "components/Menu/AddOns/AddOns";

const Menus = () => {
  const { user, userPermissions } = useSelector((state) => state.auth);

  const location = useLocation();
  const history = useHistory();

  const queryParams = new URLSearchParams(location.search);
  const tabParam = queryParams.get("tab");

  const menuTabs = [
    {
      id: "menuDetails",
      name: "Menu Details",
      access: user?.type === "restaurant" || userPermissions?.menus?.active,
      content: user?.type === "kitchen-waiter" ? <WaiterMenu/> : <Menu />,
    },
    {
      id: "labels",
      name: "Labels",
      access:
        user?.type === "restaurant" || userPermissions?.menus?.label?.active,
      content: <MenuLabels />,
    },
    {
      id: "addOns",
      name: "Add Ons",
      access:
        user?.type === "restaurant" || userPermissions?.menus?.addOns?.active,
      content: <AddOns />,
    },
  ];

  const accessibleTabs = menuTabs.filter((tab) => tab.access);
  const defaultTab =
    accessibleTabs.find((tab) => tab.id === tabParam)?.id ||
    accessibleTabs[0]?.id;

  const [selectedTab, setSelectedTab] = useState(defaultTab);

  useEffect(() => {
    const search = new URLSearchParams(location.search);
    if (selectedTab && selectedTab !== tabParam) {
      search.set("tab", selectedTab);
      history.replace({ search: search.toString() });
    }
  }, [selectedTab, history, location.search, tabParam]);

  return (
    <>
      <OnlyHeader />
      <Container className="mt--7 pt-2" fluid>
        <Tabs
          tabs={accessibleTabs}
          selectedTab={selectedTab}
          onTabChange={setSelectedTab}
        />
      </Container>
    </>
  );
};

export default Menus;
